/**
 * Runtime access to the deployment stage.
 *
 * The `sohailmh` token is substituted at build time by the Katal website
 * stack (see WHSEAPCDK/lib/katal-website-stack.ts -> Stage: props.stage) and
 * resolves to one of "beta" | "gamma" | "prod". In local development the token
 * is left un-substituted, in which case we treat the stage as "local".
 */
export type Stage = "local" | "beta" | "gamma" | "prod";

const RAW_STAGE = "sohailmh";

export const getStage = (): Stage => {
  // When the token was not substituted (local dev), fall back to "local".
  if (RAW_STAGE.startsWith("{{")) {
    return "local";
  }
  return RAW_STAGE.toLowerCase() as Stage;
};

/**
 * Default value for the `austin_enabled` query parameter per stage.
 * Only Gamma defaults to true. Beta, Prod, personal stacks and local dev
 * default to false so the in-development Austin experience is not exposed to
 * prod users. It remains reachable anywhere via an explicit URL override.
 */
export const getAustinEnabledDefault = (): boolean => {
  const stage = getStage();
  return stage === "gamma";
};
